import { render, staticRenderFns } from "./DevisLayout.vue?vue&type=template&id=6ae2bc4a&"
import script from "./DevisLayout.vue?vue&type=script&lang=js&"
export * from "./DevisLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports